'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = includeReplace;
function includeReplace() {
  return {
    require: 'ngInclude',
    restrict: 'A',
    link: function link(scope, el) {
      el.replaceWith(el.children());
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/include.replace.directive.js
// module id = 145
// module chunks = 2